import { Routes } from '@angular/router';
import { IntegrationsComponent } from './integrations.component';

export enum IntegrationRoutes {
  DAT = 'DAT',
  TRUCKSTOP = 'Truckstop',
  TELEGRAM = 'Telegram',
  GREENSCREENS = 'Greenscreens',
  HIGHWAY = 'Highway',
  ITRACKER = 'iTracker',
}

export const INTEGRATIONS_ROUTES: Routes = [
  {
    path: '',
    component: IntegrationsComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/integrations-list/integrations-list.component').then(
            (m) => m.IntegrationsListComponent
          ),
      },
      {
        path: IntegrationRoutes.DAT,
        loadChildren: () =>
          import('./pages/integrations-dat/integrations-dat-routing').then(
            (m) => m.INTEGRATIONS_DAT_ROUTES
          ),
      },
      {
        path: IntegrationRoutes.TRUCKSTOP,
        loadChildren: () =>
          import(
            './pages/integrations-truckstop/integrations-truckstop-routing'
          ).then((m) => m.INTEGRATIONS_TRUCKSTOP_ROUTES),
      },
      {
        path: IntegrationRoutes.TELEGRAM,
        loadChildren: () =>
          import(
            './pages/integrations-telegram/integrations-telegram-routing'
          ).then((m) => m.INTEGRATIONS_TELEGRAM_ROUTES),
      },
      {
        path: IntegrationRoutes.GREENSCREENS,
        loadChildren: () =>
          import(
            './pages/integrations-greenscreens/integrations-greenscreens-routing'
          ).then((m) => m.INTEGRATIONS_GREENSCREENS_ROUTES),
      },
      {
        path: IntegrationRoutes.ITRACKER,
        loadChildren: () =>
          import(
            './pages/integrations-itracker/integrations-itracker-routing'
          ).then((m) => m.INTEGRATIONS_ITRACKER_ROUTES),
      },
      {
        path: IntegrationRoutes.HIGHWAY,
        loadChildren: () =>
          import(
            './pages/integrations-highway/integrations-highway-routing'
          ).then((m) => m.INTEGRATIONS_HIGHWAY_ROUTES),
      },
    ],
  },
];
